import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-pods-list-table-skeleton',
  templateUrl: './pods-list-table-skeleton.component.html',
  styleUrls: ['./pods-list-table-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class PodsListTableSkeletonComponent {
  readonly rows = [1, 2, 3, 4, 5, 6];
}